export { default } from './BensServicosTemplate';
